import jQuery from "jquery";
const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)

/*
 * Home
*/

// $ npm install swiper
// import Swiper from 'swiper'; // import Swiper JS
import Swiper from 'swiper/bundle'; // import Swiper JS ALL

// Home - Hero
const homeSwiper = new Swiper('#home-hero-swiper', {
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
});

// Home - Swiper
const homeFullSwiper = new Swiper('#home-content-swiper', {
  loop: true,
  // slidesPerView: 1,
  spaceBetween: 12,
  centeredSlides: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    991: {
      spaceBetween: 48,
      // initialSlide: 1,
    }
  }
});

const testFullSwiper = new Swiper('#home-l-swiper', {
  slidesPerView: 1,
  spaceBetween: 12,
  centeredSlides: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    991: {
      slidesPerView: 3,
      spaceBetween: 48,
      initialSlide: 1,
    }
  }
});
const test2FullSwiper = new Swiper('#home-m-swiper', {
  slidesPerView: 1,
  spaceBetween: 12,
  centeredSlides: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    991: {
      slidesPerView: 3,
      spaceBetween: 48,
      initialSlide: 2,
    }
  }
});
